import { Component } from "@angular/core";
import { ToggleThemeService } from "@corporate-tailwind/widget";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: 'app-confirm-email-ko',
    imports: [TranslateModule],
    templateUrl: './confirm-email-ko.component.html',
    styleUrl: './confirm-email-ko.component.scss'
})
export class ConfirmEmailKoComponent {

    constructor(
        public _toggleThemeService: ToggleThemeService
    ) {}

    ngOnInit(): void {
        // Initialize theme and direction on component load
        this._toggleThemeService.initializeTheme();
    }

    // Toggle theme between light and dark
    toggleTheme() {
        this._toggleThemeService.toggleTheme();
    }

    // Toggle direction between LTR and RTL
    toggleDirection() {
        this._toggleThemeService.toggleDirection();
    }

    closeWindow() {
        window.close();
    }

}